import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  substageStatus: any;
  private progress$ = new BehaviorSubject<any>({});
  progressStatusValue$ = this.progress$.asObservable();

  private answered$ = new BehaviorSubject<any>({});
  answeredCount$ = this.answered$.asObservable();

  private toggleProgressChange$ = new BehaviorSubject<boolean>(false);
  isAssessmentProgressChange$ = this.toggleProgressChange$.asObservable();

  private confirmation$ = new BehaviorSubject<any>({});
  confirmationStatus$ = this.confirmation$.asObservable();

  private submitConfirmation$ = new BehaviorSubject<any>({});
  submitConfirmationStatus$ = this.submitConfirmation$.asObservable();

  private reduceQuesCount$ = new BehaviorSubject<any>({});
  reduceQuesCountValue$ = this.reduceQuesCount$.asObservable();

  private categoryChange$ = new BehaviorSubject<any>({});
  isCategoryChange$ = this.categoryChange$.asObservable();

  constructor() { }

  setAssessmentProgressChange(isChange: any) {
    this.toggleProgressChange$.next(isChange);
  }

  setStatusOfSubstages(subStagesDetails: any) {
    this.substageStatus = subStagesDetails;
  }

  getStatusOfSubstages() {
    return this.substageStatus;
  }

  setProgressStatus(progressStatus: any) {
    this.progress$.next(progressStatus);
  }
  setCountOfAnswered(countOfAns: any) {
    this.answered$.next(countOfAns);
  }

  setConfirmation(confirmation: any) {
    this.confirmation$.next(confirmation);
  }

  setSubmitConfirmation(confirmation: any) {
    this.submitConfirmation$.next(confirmation);
  }

  setCountReduce(countReduce: any) {
    this.reduceQuesCount$.next(countReduce);
  }

  setCategoryChange(isChange: any) {
    this.categoryChange$.next(isChange);
  }
}
